import React from "react";
import ReactDOM from "react-dom/client";
import { AppRoutes } from "./AppRoutes";
import "./index.css";
import './styles.css';


// FILE: src/index.tsx
// Intercepta ALLA alert() så tidigt som möjligt (även före App() körs)
// (gör alert helt tyst när ?debug=1 — inga konsolloggar)
if (new URLSearchParams(location.search).get("debug") === "1") {
  window.alert = (_msg: any) => {
    // Avsiktligt tom för att tysta ner alla alerts i debug-läge.
  };
}


const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AppRoutes />
  </React.StrictMode>
);

// --- DEV HELPERS: registrera på window (endast i dev) ---
if (process.env.NODE_ENV !== "production") {
  (function initDevHelpers() {
    const ensureAuthReady = async () => {
      const w = window as any;
      if (!w.auth) throw new Error("Auth/App saknas. Ladda om och logga in.");
      if (!w.auth.currentUser) {
        await new Promise<void>((resolve) => {
          const off = w.auth.onAuthStateChanged((u: any) => { if (u) { off(); resolve(); } });
        });
      }
      await w.auth.currentUser.getIdToken(true);
      return w.auth.app;
    };

    const getFns = async () => {
      const app = await ensureAuthReady();
      const { getFunctions } = await import("firebase/functions");
      return getFunctions(app, "europe-west1");
    };

    (window as any).callFn = async (name: string, data: any = {}) => {
      const fns = await getFns();
      const { httpsCallable } = await import("firebase/functions"); // ✅ denna
      const call = httpsCallable(fns, name);                        // ✅ bara namn
      const res = await call(data);
      console.log(`[callFn:${name}]`, res.data);
      return res.data;
    };

    (window as any).whoAmI = () => (window as any).callFn("whoAmI", {});
    console.log("[dev-helpers] callFn och whoAmI registrerade på window (index.tsx)");
  })();
}
// --- END DEV HELPERS ---
